import { client } from './client';

export const post = async (endpoint: string, body: object, config?: object) =>
  client(endpoint, { body, ...config });
